import { gql } from '@apollo/client';

export const APPROVE_ECD_REGISTRATION = gql`
  mutation ApproveECDRegistration($input: ApproveRegistrationInput!) {
    approveEcdRegistration(input: $input) {
      id
    }
  }
`;
